<template>
    <page>
        <module :title="title">
            <c-form ref="form">
                <c-form ref="editForm">
		                <c-form-column>
                            <c-form-item type="image" label="【重点实验室】图片" name="image0" required file-word="建议尺寸：550×400px"></c-form-item>
                            <c-form-item type="input" label="【重点实验室】跳转链接" name="image0_link_url" word="请填写完整链接地址，以http://或者https://开头"></c-form-item>
                            <c-form-item type="image" label="【阿尔塔有约】图片" name="image1" required file-word="建议尺寸：850×450px"></c-form-item>
                            <c-form-item type="input" label="【阿尔塔有约】跳转链接" name="image1_link_url" word="请填写完整链接地址，以http://或者https://开头"></c-form-item>
                            <c-form-item type="image" label="【标物小百科】模块图片" name="image2" required file-word="建议尺寸：850×450px"></c-form-item>
                            <c-form-item type="input" label="【标物小百科】跳转链接" name="image2_link_url" word="请填写完整链接地址，以http://或者https://开头"></c-form-item>
                            <c-form-item type="image" label="【热点检测】模块图片" name="image3" required file-word="建议尺寸：850×450px"></c-form-item>
                            <c-form-item type="input" label="【热点检测】跳转链接" name="image3_link_url" word="请填写完整链接地址，以http://或者https://开头"></c-form-item>
                        </c-form-column>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button  size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_home_image',

        components: {
        },

        props: {
            languageType: Number        //2=英文  1=中文
        },
        computed:{

        },
        watch:{
            languageType(){
                this.title = (this.languageType==1?'中文':'英文')+'首页控件图片'
            }
        },

        data() {
            return {
                title:'首页控件图片'
            }
        },

        mounted() {
	        this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: this.languageType==2?'/website/home_en/image/detail':'/website/home/image/detail',
                    data: {},
                    loading: true,
                    success: data => {
	                    if (data){
		                    var formObj = JSON.parse(data);
		                    this.$refs.editForm.set(formObj);
	                    }
                    }
                });
            },

            save() {
                this.$refs.editForm.submit({
	                url: this.languageType==2?'/website/home_en/image/edit':'/website/home/image/edit',
                    rule: {
                        image0:'请输入【重点实验室】模块图片',
                        image0_link_url: [{
                            type: 'function',
                            fun: (value, data) => {
                                var re = '^(https|http|ftp)\\:\\/\\/[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\\/[\\S]*)?$';
                                var match = data.image1_link_url.match(re)
                                if (!data.image1_link_url || match){
                                    return true;
                                }
                                return false;
                            },
                            word: '请正确填写【重点实验室】跳转链接地址格式'
                        }],
                        image1:'请输入【阿尔塔有约】模块图片',
                        image1_link_url: [{
                            type: 'function',
                            fun: (value, data) => {
                                var re = '^(https|http|ftp)\\:\\/\\/[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\\/[\\S]*)?$';
                                var match = data.image1_link_url.match(re)
                                if (!data.image1_link_url || match){
                                    return true;
                                }
                                return false;
                            },
                            word: '请正确填写【阿尔塔有约】跳转链接地址格式'
                        }],
                        image2:'请输入【标物小百科】模块图片',
                        image2_link_url: [{
                            type: 'function',
                            fun: (value, data) => {
                                var re = '^(https|http|ftp)\\:\\/\\/[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\\/[\\S]*)?$';
                                var match = data.image2_link_url.match(re)
                                if (!data.image2_link_url || match){
                                    return true;
                                }
                                return false;
                            },
                            word: '请正确填写【标物小百科】跳转链接地址格式'
                        }],
                        image3:'请输入【热点检测】模块图片',
                        image3_link_url: [{
                            type: 'function',
                            fun: (value, data) => {
                                var re = '^(https|http|ftp)\\:\\/\\/[a-zA-Z0-9\\-\\.]+\\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\\/[\\S]*)?$';
                                var match = data.image3_link_url.match(re)
                                if (!data.image3_link_url || match){
                                    return true;
                                }
                                return false;
                            },
                            word: '请正确填写【热点检测】跳转链接地址格式'
                        }]
                    },
                    dataFormatter: data => {
						var submitObj = {};
	                    submitObj.control_configure = JSON.stringify(data)
                        return submitObj;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .invoice-list {
    .item {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      padding: 10px 15px;
      margin-right: 26px;
      margin-bottom: 26px;
      background: #F9F9F9;

      p {
        padding: 5px 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
      }

      .handle {
        margin-top: 20px;
        text-align: right;

        a {
          margin-left: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }

    .add {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      border: 1px dashed #ddd;
      font-size: 50px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        theme-border(main);
        theme-color(main);
      }
    }
  }
</style>